import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { Icon } from '../icon/icon.component.js';
import { Text } from '../text/text.component.js';
import useId from '../../utils/use-id.js';
import { Label, Checkmark, Input } from './checkbox.style.js';

const Checkbox = props => {
    const { checked, children, className = '', disabled, error, id: _id, margin, name, onChange, usePartialCheck } = props, rest = __rest(props, ["checked", "children", "className", "disabled", "error", "id", "margin", "name", "onChange", "usePartialCheck"]);
    const id = useId('checkbox', _id);
    let iconColor = 'accent9';
    if (error)
        iconColor = 'errorBright';
    if (disabled)
        iconColor = 'secondary';
    return (jsxs(Fragment, { children: [jsxs(Label, Object.assign({ className: className, disabled: disabled, error: error, htmlFor: id, margin: margin }, { children: [jsxs(Checkmark, Object.assign({ checked: checked, disabled: disabled, error: error }, { children: [jsx(Input, Object.assign({}, rest, { checked: checked, disabled: disabled, id: id, name: name, onChange: onChange, type: "checkbox", "aria-checked": usePartialCheck && checked ? 'mixed' : checked }), void 0), checked && (jsx(Icon, { icon: usePartialCheck
                                    ? 'CheckmarkBoxPartialInverted'
                                    : 'CheckmarkBoxInverted', color: iconColor, opacity: disabled ? 'low' : 'high' }, void 0))] }), void 0), children] }), void 0), error && (jsx(Text, Object.assign({ color: "error", margin: { left: '28px', top: '8px' } }, { children: error }), void 0))] }, void 0));
};

export { Checkbox };
